module.exports = __webpack_public_path__ + "static/img/IN.953d1b33.jpg";